import type {
  LinksFunction,
  LoaderFunctionArgs,
  MetaFunction,
} from '@remix-run/node'
import { Outlet } from '@remix-run/react'
import { json } from '@remix-run/server-runtime'

import { makeTitle } from '~/helpers/pages'
import { getSessionSeller } from '~/services/auth-seller.server'

export const links: LinksFunction = () => [
  { rel: 'stylesheet', href: `/fonts.css?v=2023-11-28` },
]

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const sessionSeller = await getSessionSeller(request)

  return json({
    sessionSeller,
    baseUrl: process.env.APP_URL,
  })
}

export const meta: MetaFunction<typeof loader> = ({ data }) => {
  const baseUrl = data?.baseUrl

  return [
    { title: makeTitle() },
    {
      name: 'description',
      content:
        'Protocol - A modern e-commerce platform for creators and entrepreneurs',
    },

    // Favicon
    {
      tagName: 'link',
      rel: 'icon',
      type: 'image/x-icon',
      href: '/favicon.ico',
    },
    { tagName: 'link', rel: 'icon', type: 'image/png', href: '/favicon.png' },
    {
      tagName: 'link',
      rel: 'shortcut icon',
      type: 'image/png',
      href: '/favicon.png',
    },
    { tagName: 'link', rel: 'apple-touch-icon', href: '/favicon.png' },

    // Open Graph / Facebook
    { property: 'og:type', content: 'website' },
    { property: 'og:title', content: makeTitle() },
    {
      property: 'og:description',
      content:
        'Protocol - A modern e-commerce platform for creators and entrepreneurs',
    },
    ...(baseUrl ? [{ property: 'og:url', content: baseUrl }] : []),
    ...(baseUrl
      ? [{ property: 'og:image', content: `${baseUrl}/gradient.png` }]
      : []),
    { property: 'og:site_name', content: 'Protocol' },

    // Twitter
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: makeTitle() },
    {
      name: 'twitter:description',
      content:
        'Protocol - A modern e-commerce platform for creators and entrepreneurs',
    },
    ...(baseUrl
      ? [{ name: 'twitter:image', content: `${baseUrl}/gradient.png` }]
      : []),

    { name: 'robots', content: 'index, follow' },
    { name: 'author', content: 'Protocol' },

    ...(baseUrl ? [{ tagName: 'link', rel: 'canonical', href: baseUrl }] : []),
  ]
}

export default function MainLayout() {
  return (
    <div
      className="bg-background relative size-full"
      data-theme="protocol-dark"
    >
      <Outlet />
    </div>
  )
}
